(() => {
  'use strict';
  const critical = 'a[href], button, input, select, textarea, label, video, iframe, .ry-button, .ry-finder-page__button, .ry-product-mobile-cta, .ry-sticky-purchase';
  const controls = new Set();
  const visible = new Set();
  let queued = false;
  let observer;

  function schedule() {
    if (!queued) {
      queued = true;
      requestAnimationFrame(updateHelp);
    }
  }

  function track(node) {
    if (controls.has(node)) return;
    controls.add(node);
    if (observer) observer.observe(node);
    else visible.add(node);
  }

  function collect(root) {
    if (root.nodeType !== 1) return;
    if (root.matches(critical)) track(root);
    root.querySelectorAll(critical).forEach(track);
  }

  function updateHelp() {
    queued = false;
    const chat = document.getElementById('whatsapp-embed-button');
    if (!chat) return;
    const wrapper = document.getElementById('whatsapp-embed-wrapper') || chat;
    const host = document.querySelector('.ry-cart-support, .ry-chooser__intro');
    if (host) {
      if (!host.contains(wrapper)) host.appendChild(wrapper);
      wrapper.classList.add('ry-chat-inline');
      wrapper.classList.remove('ry-chat-clearance');
      chat.classList.remove('ry-chat-clearance');
      chat.removeAttribute('aria-hidden');
      chat.removeAttribute('tabindex');
      return;
    }
    const box = chat.getBoundingClientRect();
    let covered = false;
    for (const node of visible) {
      if (!node.isConnected || chat.contains(node) || node.contains(chat)) continue;
      const target = node.getBoundingClientRect();
      if (target.width > 0 && target.height > 0 && target.bottom > 0 && target.top < innerHeight &&
          box.left < target.right + 12 && box.right > target.left - 12 &&
          box.top < target.bottom + 12 && box.bottom > target.top - 12) {
        covered = true;
        break;
      }
    }
    const hide = covered && !chat.contains(document.activeElement);
    wrapper.classList.toggle('ry-chat-clearance', hide);
    if (hide) {
      chat.setAttribute('aria-hidden', 'true');
      chat.setAttribute('tabindex', '-1');
    } else {
      chat.removeAttribute('aria-hidden');
      chat.removeAttribute('tabindex');
    }
  }

  function init() {
    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (entry.isIntersecting) visible.add(entry.target);
          else visible.delete(entry.target);
        }
        schedule();
      }, {rootMargin: '12px'});
    }
    collect(document.body);
    new MutationObserver(records => {
      let removed = false;
      for (const record of records) {
        record.addedNodes.forEach(collect);
        if (record.removedNodes.length) removed = true;
      }
      if (removed) {
        for (const node of controls) {
          if (node.isConnected) continue;
          if (observer) observer.unobserve(node);
          controls.delete(node);
          visible.delete(node);
        }
      }
      schedule();
    }).observe(document.body, {childList: true, subtree: true});
    window.addEventListener('scroll', schedule, {passive: true});
    window.addEventListener('resize', schedule, {passive: true});
    window.addEventListener('load', schedule, {once: true});
    document.addEventListener('shopify:section:load', schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
})();

(() => {
  'use strict';
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ry-copy-employer]');
    if (!button) return;
    const field = document.getElementById(button.dataset.ryCopyEmployer);
    const panel = button.closest('.ry-employer-request');
    const status = panel && panel.querySelector('[data-ry-copy-status]');
    if (!field || !status) return;
    try {
      if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Manual copy');
      await navigator.clipboard.writeText(field.value);
      status.textContent = 'Email copied. Paste it into your email and adapt it for your workplace.';
    } catch (_) {
      field.focus();
      field.select();
      status.textContent = 'Message selected. Use your device’s copy command, then paste it into your email.';
    }
  });
})();
